export default __webpack_public_path__ + "static/Corprate_WhoWeAre_SLT_06-43fc681d5f3e69df677cb63adbe8477b.jpg";